/**
 * Remove legacy staff JWT keys from localStorage after migrating to httpOnly cookies.
 * Loyalty keys (loyalty_token, loyalty_user) are intentionally kept — they persist
 * the Sanctum bearer for mobile QR / cold-tab opens where cross-subdomain cookies fail.
 */
export function clearLegacyAuthStorage() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch {
    // ignore
  }
}
